import { MenuItem, Stack, TextField } from "@mui/material"
import { Case, Switch } from "lib/@components/switch"
import { CostModifierInput } from "./cost-modifier-input"
import { TimeModifierInput } from "./time-modifier-input"
import { FrequencyModifierInput } from "./frequency-modifier-input"

export function RuleActionSelector({ action, onUpdate }) {
    const type = action.type || "include"

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <TextField select value={type} onChange={handleTypeChange} sx={{ minWidth: 220 }}>
                <MenuItem value="include">Include</MenuItem>
                <MenuItem value="exclude">Exclude</MenuItem>
                <MenuItem value="modifier">Apply cost modifier</MenuItem>
                <MenuItem value="timeModifier">Apply time modifier</MenuItem>
                <MenuItem value="frequencyModifier">Apply frequency modifier</MenuItem>
            </TextField>
            <Switch value={type}>
                <Case when="modifier">
                    <CostModifierInput
                        costKind={action.costKind}
                        multiplier={action.multiplier}
                        fixedAmount={action.fixedAmount}
                        onChange={handleCostChange}
                    />
                </Case>
                <Case when="timeModifier">
                    <TimeModifierInput
                        timeKind={action.timeKind}
                        timeValue={action.timeValue}
                        onChange={handleTimeChange}
                    />
                </Case>
                <Case when="frequencyModifier">
                    <FrequencyModifierInput multiplier={action.frequencyMultiplier} onChange={handleFrequencyChange} />
                </Case>
            </Switch>
        </Stack>
    )

    function handleTypeChange(e) {
        const type = e.target.value
        if (type === "modifier") {
            onUpdate({
                type,
                costKind: action.costKind ?? "multiplier",
                multiplier: action.multiplier ?? 1.0,
                fixedAmount: action.fixedAmount ?? 0,
            })
            return
        }
        if (type === "timeModifier") {
            onUpdate({
                type,
                timeKind: action.timeKind ?? "minutes",
                timeValue: action.timeValue ?? 10,
            })
            return
        }
        if (type === "frequencyModifier") {
            onUpdate({ type, frequencyMultiplier: action.frequencyMultiplier ?? 1.0 })
            return
        }
        onUpdate({ type })
    }

    function handleCostChange({ costKind, multiplier, fixedAmount }) {
        onUpdate({ ...action, costKind, multiplier, fixedAmount })
    }

    function handleTimeChange({ timeKind, timeValue }) {
        onUpdate({ ...action, timeKind, timeValue })
    }

    function handleFrequencyChange(frequencyMultiplier) {
        onUpdate({ ...action, frequencyMultiplier })
    }
}
